export default __webpack_public_path__ + "static/media/Milou.33475815.jpg";